export default __webpack_public_path__ + "static/media/unsubscribed.33f7e1c9.svg";